import { render, staticRenderFns } from "./VideoCallSubScreen.vue?vue&type=template&id=2447eacd&scoped=true&"
import script from "./VideoCallSubScreen.vue?vue&type=script&lang=ts&"
export * from "./VideoCallSubScreen.vue?vue&type=script&lang=ts&"
import style0 from "./VideoCallSubScreen.vue?vue&type=style&index=0&id=2447eacd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2447eacd",
  null
  
)

export default component.exports